const routes = {
  getCurrencies: 'system/currencies',
  getCurrenciesPreview: 'system/currencies/with-out-token',
  updateCurrencyRate: 'system/updateCurrency',
  getCurrenciesLogs: 'system/currencies/logs',
};

export default routes